<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="editRule">
        <div class="row">
          <div class="col-12 mb-3">
            <h6 class="text-primary fw-semibold border-bottom pb-2">
              <i class="ri-information-line"></i> Informations générales
            </h6>
          </div>

          <!-- Jeu de règles -->
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Jeu de règles <span class="text-danger">*</span>
              </label>
              <Multiselect :options="ruleSetOptions" :searchable="true" track-by="value" label="label" :object="true"
                v-model="formData.ruleset" placeholder="Sélectionner le jeu de règles" />
            </div>
          </div>

          <!-- Code -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Code <span class="text-danger">*</span>
              </label>
              <Field name="code" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le code" v-model="formData.code" />
              <ErrorMessage name="code" class="text-danger" />
            </div>
          </div>

          <!-- Name -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nom <span class="text-danger">*</span>
              </label>
              <Field name="name" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le nom" v-model="formData.name" />
              <ErrorMessage name="name" class="text-danger" />
            </div>
          </div>

          <!-- Description -->
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Description <span class="text-danger">*</span>
              </label>
              <Field name="description" as="textarea" class="form-control shadow-none fs-md-15 text-black"
                v-model="formData.description" />
              <ErrorMessage name="description" class="text-danger" />
            </div>
          </div>

          <!-- Configuration -->
          <div class="col-12 mb-3 mt-3">
            <h6 class="text-primary fw-semibold border-bottom pb-2">
              <i class="ri-settings-3-line"></i> Configuration de la règle
            </h6>
          </div>

          <!-- Target Entity -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Type d’entité ciblée <span class="text-danger">*</span>
              </label>
              <Multiselect :options="targetOptions" label="label" track-by="value" :object="true"
                v-model="target_entity_type" placeholder="Sélectionner le type d'entité" />
            </div>
          </div>

          <!-- Severity -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Sévérité</label>
              <Multiselect :options="severityOptions" label="label" track-by="value" v-model="severity" :object="true"
                placeholder="Sélectionner la sévérité" />
            </div>
          </div>

          <!-- Auto Flag Type -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Type d'auto-flag
              </label>
              <Multiselect :options="autoFlagTypeOptions" label="label" track-by="value" v-model="auto_flag_type"
                :object="true" placeholder="Sélectionner le type d'alerte" />
            </div>
          </div>

          <!-- Condition expression -->
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Expression de condition
              </label>
              <Field name="condition_expression" as="textarea" class="form-control shadow-none fs-md-15 text-black"
                v-model="formData.condition_expression" />
              <ErrorMessage name="condition_expression" class="text-danger" />
              <small class="text-muted">Format JSON pour définir la logique de contrôle</small>
            </div>
          </div>

          <!-- Moments d'exécution -->
          <div class="col-12 mb-3 mt-3">
            <h6 class="text-primary fw-semibold border-bottom pb-2">
              <i class="ri-time-line"></i> Moments d'exécution
            </h6>
          </div>

          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="form-check mb-2">
                <input type="checkbox" class="form-check-input" name="run_on_creation"
                  v-model="formData.run_on_creation" />
                <label class="form-check-label">
                  Exécuter à la création/soumission du dossier
                </label>
              </div>

              <div class="form-check mb-2">
                <input type="checkbox" class="form-check-input" name="run_on_update" v-model="formData.run_on_update" />
                <label class="form-check-label">
                  Exécuter lors des mises à jour
                </label>
              </div>

              <div class="form-check">
                <input type="checkbox" class="form-check-input" name="run_on_pre_issuance"
                  v-model="formData.run_on_pre_issuance" />
                <label class="form-check-label">
                  Exécuter obligatoirement avant émission (contrôle bloquant)
                </label>
              </div>
            </div>
          </div>

          <!-- Période d'application -->
          <div class="col-12 mb-3 mt-3">
            <h6 class="text-primary fw-semibold border-bottom pb-2">
              <i class="ri-calendar-line"></i> Période d'application
            </h6>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date d’entrée en vigueur
              </label>
              <Field name="effective_from" type="date" class="form-control shadow-none fs-md-15 text-black"
                v-model="formData.effective_from" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de fin d’application
              </label>
              <Field name="effective_to" type="date" class="form-control shadow-none fs-md-15 text-black"
                v-model="formData.effective_to" />
            </div>
          </div>

          <!-- Activer -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Activer
              </label>
              <input type="checkbox" class="form-check-input" name="is_enabled" v-model="formData.is_enabled" />
            </div>
          </div>

          <!-- Boutons -->
          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <button type="submit"
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success">
                Modifier une règle de contrôle individuelle
              </button>
              <router-link to="/listeRule" class="btn btn-danger transition border-0 lh-1 fw-medium">
                Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, reactive, nextTick } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRoute, useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import Multiselect from '@vueform/multiselect';

export default defineComponent({
  name: 'EditRule',
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },

  setup() {
    const router = useRouter();
    const route = useRoute();
    const ruleId = route.params.id as string;

    const targetOptions = [
      { value: 'BESC_FILE', label: 'Dossier BESC' },
      { value: 'BILL_OF_LADING', label: 'Connaissement (BL)' },
      { value: 'BL_ITEM', label: 'Ligne de marchandise' },
      { value: 'PARTY', label: 'Partie (shipper, consignee...)' },
      { value: 'SUPPORTING_DOCUMENT', label: 'Document justificatif' },
    ];

    const severityOptions = [
      { value: 'INFO', label: 'Information' },
      { value: 'WARNING', label: 'Avertissement' },
      { value: 'BLOCKING', label: 'Bloquant' },
      { value: 'HIGH_RISK', label: 'Risque élevé' },
    ];

    const autoFlagTypeOptions = [
      { value: 'RISK_ALERT', label: 'Alerte de risque' },
      { value: 'MANDATORY_REVIEW', label: 'Révision obligatoire' },
      { value: 'HARD_BLOCK', label: 'Blocage strict' },
      { value: 'DOCUMENT_MISSING', label: 'Document manquant' },
      { value: 'VALUE_MISMATCH', label: 'Incohérence de valeur' },
      { value: 'BLACKLIST_HIT', label: 'Correspondance liste noire' },
    ];

    interface Option {
      value: string;
      label: string;
    }

    const ruleSetOptions = ref<Option[]>([]);
    // Plus besoin de ref séparé pour ruleset → on utilise formData.ruleset
    const target_entity_type = ref<{ value: string; label: string } | null>(null);
    const severity = ref<{ value: string; label: string } | null>(null);
    const auto_flag_type = ref<{ value: string; label: string } | null>(null);

    // Typage correct pour ruleset
    const formData = reactive({
      code: '',
      name: '',
      description: '',
      condition_expression: '',
      effective_from: '',
      effective_to: '',
      run_on_creation: false,
      run_on_update: false,
      run_on_pre_issuance: false,
      is_enabled: false,
      ruleset: null as { value: string; label: string } | null, // Typage explicite
    });

    const formatDate = (dateString: string | null): string => {
      if (!dateString) return '';
      return dateString.split('T')[0];
    };

    const fetchRulesets = async () => {
      try {
        const response = await ApiService.get('/ruleset');
        // ruleSetOptions.value = response.data.data.data.map((ruleset: any) => ({
        //   value: ruleset.id,
        //   label: `${ruleset.code} ${ruleset.name}`,
        // }));
        const ruleData= response.data.data.data;
        ruleSetOptions.value= ruleData.map((r: any) => ({
          value: r.id,
          label: `${r.name}`
        }))
      } catch (err) {
        console.error('Erreur fetch rulesets', err);
      }
    };

    const getRule = async (id: string) => {
      try {
        const response = await ApiService.get(`/rule/${id}`);
        const rule = response.data.data;
        console.log('Règle chargée :', rule);

        // Champs simples
        formData.code = rule.code || '';
        formData.name = rule.name || '';
        formData.description = rule.description || '';
        formData.condition_expression = rule.condition_expression || '';

        formData.run_on_creation = !!rule.run_on_creation;
        formData.run_on_update = !!rule.run_on_update;
        formData.run_on_pre_issuance = !!rule.run_on_pre_issuance;
        formData.is_enabled = !!rule.is_enabled;

        formData.effective_from = formatDate(rule.effective_from);
        formData.effective_to = formatDate(rule.effective_to);

        // Multiselect statiques (déjà parfait)
        target_entity_type.value = targetOptions.find(o => o.value === rule.target_entity_type) || null;
        severity.value = severityOptions.find(o => o.value === rule.severity) || null;
        auto_flag_type.value = autoFlagTypeOptions.find(o => o.value === rule.auto_flag_type) || null;
        formData.ruleset= rule.ruleset ? {value: rule.ruleset.id, 
          label: `${rule.ruleset.name}`
        }: null;
       
        // Un dernier nextTick pour être sûr que tout est rafraîchi
        await nextTick();

      } catch (e: any) {
        error(e.response?.data?.message || 'Erreur chargement règle');
      }
    };
    const editRule = async () => {
      try {
        const payload = {
          code: formData.code,
          name: formData.name,
          description: formData.description,
          condition_expression: formData.condition_expression || null,
          effective_from: formData.effective_from || null,
          effective_to: formData.effective_to || null,
          ruleset: formData.ruleset ? formData.ruleset.value : null,
          target_entity_type: target_entity_type.value?.value ?? null,
          severity: severity.value?.value ?? null,
          auto_flag_type: auto_flag_type.value?.value ?? null,
          run_on_creation: formData.run_on_creation,
          run_on_update: formData.run_on_update,
          run_on_pre_issuance: formData.run_on_pre_issuance,
          is_enabled: formData.is_enabled,
        };

        await ApiService.put(`/rule/${ruleId}`, payload);
        success('Règle modifiée avec succès');
        router.push('/listeRule');
      } catch (e: any) {
        error(e.response?.data?.message || 'Erreur modification');
      }
    };

    onMounted(async () => {
      await fetchRulesets();
      if (ruleId) await getRule(ruleId);
    });

    return {
      editRule,
      ruleSetOptions,
      targetOptions,
      severityOptions,
      autoFlagTypeOptions,
      formData,
      target_entity_type,
      severity,
      auto_flag_type,
      // ruleset n'est plus un ref séparé → on ne le retourne pas
    };
  },
});
</script>